function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h140v140H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.925 91.525a2.187 2.187 0 01-2.188-2.187V49.963a4.375 4.375 0 00-4.375-4.376h-5.468a2.187 2.187 0 100 4.375h5.468v40.47a5.469 5.469 0 005.47 5.468h59.062a2.187 2.187 0 000-4.375H43.925z",
  fill: "#ABC0D8",
  fillRule: "nonzero",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.255 45.04h4.375v4.376h-4.375a2.187 2.187 0 110-4.375z",
  fill: "#FDB913",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.737 57.969v-8.007a4.375 4.375 0 00-4.375-4.375h-5.468c-1.208 0-2.188.98-2.188 2.188h0c0 1.208.98 2.188 2.188 2.188h4.375c.604 0 1.093.49 1.093 1.093v39.375a5.469 5.469 0 005.47 5.469h59.062c1.208 0 2.187-.98 2.187-2.187h0c0-1.209-.98-2.188-2.187-2.188H43.925a2.187 2.187 0 01-2.188-2.187V74.123",
  stroke: "#F58220",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F58220",
  strokeWidth: 2,
  fill: "#FFF",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 52.128,
  cy: 93.166,
  r: 7.109
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FDB913",
  fillRule: "nonzero",
  cx: 52.128,
  cy: 93.166,
  r: 3.828
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F58220",
  strokeWidth: 2,
  fill: "#FFF",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 86.034,
  cy: 93.166,
  r: 7.109
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FDB913",
  fillRule: "nonzero",
  cx: 86.034,
  cy: 93.166,
  r: 3.828
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#ABC0D8",
  fillRule: "nonzero",
  opacity: 0.3,
  cx: 89.709,
  cy: 51.92,
  r: 15.083
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F58220",
  strokeWidth: 2,
  fill: "#FDB913",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 91.897,
  cy: 48.639,
  r: 15.083
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M97.289 54.042L86.505 43.247m0 10.795l10.784-10.795"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#F1823B",
  strokeWidth: 2,
  cx: 27.333,
  cy: 92.619,
  r: 2.734
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#ABC0D8",
  fillRule: "nonzero",
  opacity: 0.3,
  cx: 111.552,
  cy: 26.994,
  r: 2.734
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.022 26.22l2.098-2.097a.65.65 0 01.919 0l2.097 2.097a.65.65 0 010 .92l-2.097 2.097a.65.65 0 01-.92 0l-2.097-2.097a.65.65 0 010-.92zm64.452 47.482l1.911-1.911a.59.59 0 01.835 0l1.91 1.911a.59.59 0 010 .834l-1.91 1.912a.59.59 0 01-.835 0l-1.91-1.912a.59.59 0 010-.834zm-74.425 38.616l2.46-2.46a.76.76 0 011.074 0l2.46 2.46a.76.76 0 010 1.075l-2.46 2.46a.76.76 0 01-1.074 0l-2.46-2.46a.76.76 0 010-1.075zM23.894 36.89l2.033-2.033a.63.63 0 01.89 0l2.033 2.033a.63.63 0 010 .89l-2.032 2.033a.63.63 0 01-.891 0l-2.033-2.032a.63.63 0 010-.891z",
  fill: "#FDB913",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.892 111.893l2.5-2.501a.78.78 0 011.104 0l2.5 2.5a.78.78 0 010 1.104l-2.5 2.5a.78.78 0 01-1.103 0l-2.501-2.5a.78.78 0 010-1.103z",
  fill: "#F1823B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F58220",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M41.737 62.891v5.468"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#ABC0D8",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M70.941 70v8.159m-11.408-4.834l5.775 5.775m17.03-5.775L76.573 79.1"
}));

function SvgIllustrationEmptyTransaction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgIllustrationEmptyTransaction;